// レビュー数をレビューを見るに変更
document.addEventListener("DOMContentLoaded", () => {
    const mxprAverageCount = document.querySelector(".mxpr-average-count");
    mxprAverageCount.innerHTML =
        '<a class="mxpr-rating-link" href="#shopify-block-mxpr_product_review_block">レビューを見る</a>';
});

// レビュー内の日時から、時間帯を削除
document.addEventListener("DOMContentLoaded", function () {
    // 日付のテキストをフォーマットする関数
    function formatDateText() {
        const createdElements = document.querySelectorAll(".mxpr-review__list-item-createdat");
        createdElements.forEach(function (element) {
            let originalText = element.textContent;
            // 時間部分を削除し、「日」で終わるようにする正規表現 (時間があってもなくても対応)
            const newText = originalText.replace(/日(\s+\d{1,2}:\d{2})?$/,"日");
            // テキストが実際に変更された場合のみ更新
            if (element.textContent !== newText) {
                element.textContent = newText;
            }
        });
    }

    // ページ読み込み完了時に一度実行
    formatDateText();

    // 監視対象のノード（レビューリスト全体）を選択
    const targetNode = document.querySelector(".mxpr-review__list");

    // targetNode が存在する場合のみ MutationObserver を設定
    if (targetNode) {
        // オブザーバーのオプション（子リストの変更を監視）
        const config = { childList: true };

        // 変更が監視されたときに実行されるコールバック関数
        const callback = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === "childList") {
                    // console.log('子ノードが追加または削除されました。');
                    formatDateText(); // 日付フォーマット関数を再実行
                    break; // 他のmutationをチェックする必要がないためループを抜ける
                }
            }
        };

        // コールバック関数にリンクされたオブザーバーのインスタンスを作成
        const reviewListObserver = new MutationObserver(callback);

        // 設定された変更の監視を開始
        reviewListObserver.observe(targetNode, config);

        // 必要に応じて、後で監視を停止することもできます
        // observer.disconnect();
    } else {
        console.warn(
            '監視対象のノード ".mxpr-review__list" が見つかりませんでした。'
        );
    }
});
// LINEポップアップ
(function() {
  var css = `
    #line-popup-overlay {
      position: fixed; inset: 0; background: rgba(0,0,0,0.4);
      z-index: 9999; display: flex; align-items: center; justify-content: center;
    }
    #line-popup {
      background: #fff; border-radius: 8px; padding: 32px 24px;
      max-width: 320px; width: 90%; text-align: center; position: relative;
    }
    #line-popup-close {
      position: absolute; top: 12px; right: 16px;
      font-size: 20px; cursor: pointer; color: #888; background: none; border: none;
    }
    #line-popup h2 { font-size: 16px; font-weight: 500; color: #513D2E; margin: 0 0 8px; }
    #line-popup p { font-size: 13px; color: #888780; line-height: 1.6; margin: 0 0 20px; }
    #line-popup-btn {
      display: flex; align-items: center; justify-content: center;
      background: #06C755; color: #fff; border-radius: 6px; padding: 12px;
      font-size: 14px; font-weight: 500; text-decoration: none;
    }
  `;
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var html = `
    <div id="line-popup-overlay" style="display:none;">
      <div id="line-popup">
        <button id="line-popup-close">✕</button>
        <img src="https://cdn.shopify.com/s/files/1/0907/1696/3186/files/LINE_Brand_icon_2.png?v=1780385216" alt="LINE" width="52" height="52" style="margin: 0 auto 16px; display: block;">
        <h2>新商品・イベント情報を<br>LINEでお届けします</h2>
        <p>cocomaniのLINEを友だち追加すると、新商品やイベントのお知らせをいち早く受け取れます。</p>
        <a id="line-popup-btn" href="https://page.line.me/689invkr?oat_content=url&openQrModal=true" target="_blank" onclick="gtag('event', 'line_popup_click', {click_url: this.href});">
  LINEで友だち追加する
</a>
      </div>
    </div>
  `;
  document.body.insertAdjacentHTML('beforeend', html);

  if (localStorage.getItem('linePopupClosed')) return;

  function showPopup() {
    document.getElementById('line-popup-overlay').style.display = 'flex';
  }

  var shown = false;
  var isMobile = window.innerWidth <= 768;

  if (isMobile) {
    window.addEventListener('scroll', function() {
      if (shown) return;
      var scrolled = window.scrollY + window.innerHeight;
      var total = document.body.scrollHeight;
      if (scrolled >= total * 0.8) {
        shown = true;
        showPopup();
      }
    });
  } else {
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 0 && !shown) {
        shown = true;
        showPopup();
      }
    });
  }

  document.getElementById('line-popup-close').addEventListener('click', function() {
    document.getElementById('line-popup-overlay').style.display = 'none';
    localStorage.setItem('linePopupClosed', '1');
  });
  document.getElementById('line-popup-overlay').addEventListener('click', function(e) {
    if (e.target === this) {
      this.style.display = 'none';
      localStorage.setItem('linePopupClosed', '1');
    }
  });
})();